import { render, staticRenderFns } from "./form-component-checkbox.vue?vue&type=template&id=1481acfe"
import script from "./form-component-checkbox.vue?vue&type=script&lang=ts"
export * from "./form-component-checkbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports